import React, { useEffect } from "react";
import AIChatWidget from "@/components/AIChatWidget";

/**
 * Standalone embeddable AI chat — used by /chat-widget route.
 * Loaded inside an <iframe> by the embed snippet (public/embed.js).
 *
 * Starts CLOSED so embed.js can keep the iframe compact (just the launcher)
 * until the user clicks; then postMessage tells the host to expand the iframe.
 */
export default function ChatWidgetEmbed() {
  useEffect(() => {
    // Sigurohu qe body & html jane transparente per iframe-in
    const prev = { html: document.documentElement.style.background, body: document.body.style.background };
    document.documentElement.style.background = "transparent";
    document.body.style.background = "transparent";
    return () => {
      document.documentElement.style.background = prev.html;
      document.body.style.background = prev.body;
    };
  }, []);
  return (
    <div style={{ background: "transparent", minHeight: "100vh", overflow: "hidden" }}>
      <AIChatWidget source="embed" defaultOpen={false} />
    </div>
  );
}
